import React from 'react';
import '../styles/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <p>&copy; {currentYear} August Ek. All rights reserved.</p>
      <p>Built with React & TypeScript</p>
    </footer>
  );
}

export default Footer;